import gsap from 'gsap';

export const triggerAnimation = ( setting, timelines, timers, index ) => {
	let theTimeline = timelines.find(
		( timeline ) => timeline.animationID === setting.theAnimation
	)?.timeline;
	const run = () => {
		timers[ index ]?.kill();
		timers[ index ] = null;
		if ( setting.delay ) {
			timers[ index ] = gsap.delayedCall( setting.delay, () => {
				theTimeline?.[ setting.action || 'play' ]();
			} );
		} else {
			theTimeline?.[ setting.action || 'play' ]();
		}
	};

	const kill = () => {
		theTimeline = null;
		timers[ index ] = null;
	};

	return { run, kill };
};
